import { Component, OnInit } from '@angular/core';
import { mergeMap, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Checklist } from '../../../classes/checklist';
import { ChecklistCategory } from "../../../classes/checklistCategory";
import { ChecklistService } from '../../../services/checklist';
import { ChecklistCategoryService } from "../../../services/checklistCategory";
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-checklist-update',
  templateUrl: './checklist-category-update.component.html',
  styleUrls: ['./checklist-category-update.component.css']
})
export class ChecklistCategoryUpdateComponent implements OnInit {
  checklist!: Checklist;
  checklistCategory!: ChecklistCategory;
  checklistCategoryUpdateResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private checklistCategoryService: ChecklistCategoryService,
              private checklistService: ChecklistService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
        this.checklistCategoryService.getByID(params.get('id'))
        .pipe(
            tap((checklistCategory: any) => {
                this.checklistCategory = checklistCategory;
            }),
            mergeMap(() => this.checklistService.getByID((this.checklistCategory.fk_id_checklist as number).toString()))
        )
        .subscribe({
          next: (checklist: any) => {
            this.checklist = checklist;
          },
          error: (err: HttpErrorResponse) => {
            console.log(err);
          }
        });
    });
  }

  onSubmit() {
    this.checklistCategoryService.update(this.checklistCategory)
      .subscribe({
        next: () => {
          this.router.navigate(['/checklist/' + this.checklist.id_checklist]);
        },
        error: (err: HttpErrorResponse) => {
          this.checklistCategoryUpdateResult = false;
          console.log(err);
        }
      });
  }

}
